import React from 'react'
import { Button, Grid, Link } from '@material-ui/core'
import classNames from 'classnames'
import { views } from 'cng-web-lib'
import { Link as RouterLink } from 'react-router-dom'
import NaCommonTranslationText from 'src/common/NaCommonTranslationText'

const { CngLoginView } = views

export const WhitelabelLogin = ({ homePagePath }) => {
  const naCommonTranslationText = NaCommonTranslationText()

  return <CngLoginView
    renderHeaderContent={() => {
      return (
        <Button
          component={RouterLink}
          to={homePagePath}
          className={classNames('btn-go-back')}
        >
          <i
            className={classNames(
              'label-icon',
              'ic-32',
              'ic-bg-white',
              'icon-arrow-back-white'
            )}
          ></i>
          Back to home
        </Button>

      )
    }}
    renderFooterContent={() => { "" }}
    renderLogo={() => { "" }}
    renderExpiredPasswordMessage={
      {
        errorMessageKey: "password has expired",
        newErrorMessage: naCommonTranslationText.userPasswordExpiredMsg,
        renderLinkContent: () => {
          return (
            <Grid item xs={12} sm={12} classes={{ root: 'align-center' }}>
              <Link
                component={RouterLink}
                to="/update-password"
                variant='body2'
                classes={{ root: 'ng-link-primary' }}
              >{naCommonTranslationText.updatePassword}</Link>
            </Grid>
          )
        }
      }
    }
  />
}